var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorAccountability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m446.786 410.463a214.846 214.846 0 0 0 -28.914-88.413c-60.572-102.812-193.039-137.027-295.823-76.45a215.221 215.221 0 0 0 -93.033 111.429 181.131 181.131 0 0 1 329.414 53.434h-33.08l78.831 78.8 78.8-78.8z",
    fill: "#267da7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.069 48.62h67.125v124.809a232.759 232.759 0 0 0 -54.17 32.089q-6.633 5.187-12.955 10.856z",
    fill: "#60b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.431 8h67.1v164.522a213.482 213.482 0 0 0 -67.1 3.941z",
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.794 78.469h67.1v122.882a262.7 262.7 0 0 0 -67.1-23.67z",
    fill: "#44bc59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.128 115.574h67.124v174.726a257.923 257.923 0 0 0 -67.124-69.959z",
    fill: "#ff3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.2 358.05h162.34v108.936c0 14.825-36.368 26.843-81.241 26.843-44.844 0-81.212-12.018-81.212-26.843z",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.3 332.652c-44.844 0-81.212 12.018-81.212 26.844 0 14.853 36.368 26.872 81.212 26.872 44.873 0 81.241-12.019 81.241-26.872 0-14.826-36.368-26.844-81.241-26.844z",
    fill: "#fdbf00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m110.172 393.766a8.561 8.561 0 0 1 7.455 3.544c3.146 4.422 12.472 8.617 25.8 11.934 14.287 3.543 32.627 5.64 52.753 5.64 20.211 0 38.608-2.126 52.951-5.7 10.942-2.721 19.134-6.038 23.414-9.553v18.482a106.908 106.908 0 0 1 -19.134 6.491c-15.732 3.941-35.659 6.293-57.231 6.293-21.43 0-41.273-2.324-56.977-6.236-12.3-3.033-22.308-7.172-29.055-12.132zm162.368 40.593v18.482a106.924 106.924 0 0 1 -19.134 6.519c-15.732 3.94-35.659 6.293-57.231 6.293-21.43 0-41.273-2.353-56.977-6.236-12.3-3.033-22.365-7.2-29.083-12.161l.028-18.737a8.549 8.549 0 0 1 7.484 3.515c3.146 4.451 12.472 8.646 25.8 11.962 14.287 3.515 32.627 5.641 52.753 5.641 20.211 0 38.608-2.126 52.951-5.7 10.942-2.722 19.134-6.038 23.414-9.581z",
    fill: "#fdbf00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m131.233 323.212-91.389 158.288 36.456 21.06c14.456 8.334 46.658-20.353 71.915-64.091s33.987-85.975 19.53-94.309z",
    fill: "#ff9100",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60.792 388.012c25.257-43.738 57.458-72.453 71.915-64.091s5.726 50.57-19.531 94.308c-25.256 43.771-57.458 72.454-71.915 64.092s-5.726-50.57 19.531-94.309z",
    fill: "#fdbf00",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorAccountability);
export default __webpack_public_path__ + "static/media/vendor-accountability.7f3754ec2a50646b3af48040e82c02c5.svg";
export { ForwardRef as ReactComponent };